<template>
  <div class="CompanyProfile">
    <div class="CompanyProfile_title">
      <el-divider>
        <div class="CompanyProfile_title_name">公司简介</div>
        <div class="CompanyProfile_title_text">About US</div>
      </el-divider>
    </div>
    <!-- About US -->
    <div class="CompanyProfile_content">
      <div class="CompanyProfile_content_left">
        <img class="about_us_img" src="../assets/qingyeLogo.png" alt="" />
      </div>
      <div class="CompanyProfile_content_right">
        <p class="CompanyProfile_content_right_p1">"</p>
        <div class="CompanyProfile_content_right_text" v-html="content"></div>
        <p class="CompanyProfile_content_right_p2">"</p>
      </div>
    </div>
    <div class="CompanyProfile_foot">
      <div class="CompanyProfile_foot_title">
        <el-divider>
          <div class="CompanyProfile_foot_title_name">发展历程</div>
          <div class="CompanyProfile_foot_title_text">Development course</div>
        </el-divider>
      </div>
      <div class="CompanyProfile_foot_img">
        <img :src="courseImage" alt="" />
      </div>
    </div>
    <div class="CompanyProfile_bottom">
      <div class="CompanyProfile_bottom_title">
        <el-divider>
          <div class="CompanyProfile_bottom_title_name">企业文化</div>
          <div class="CompanyProfile_bottom_title_text">Corporate Culture</div>
        </el-divider>
      </div>
      <div class="CompanyProfile_bottom_content">
        <div
          class="CompanyProfile_bottom_content_div"
          v-for="(item, index) in cultureDtoList"
          :key="index"
        >
          <div class="CompanyProfile_bottom_content_div_img">
            <!--<img :src="item.imgSrc" alt="">-->
          </div>
          <div class="CompanyProfile_bottom_content_div_text">
            <div class="CompanyProfile_bottom_content_div_text_left">
              {{ item.title }}
            </div>
            <div class="CompanyProfile_bottom_border"></div>
            <div class="CompanyProfile_bottom_content_div_text_right">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCompanyInfoApi } from "@/api/index";

export default {
  data() {
    return {
      content: "",
      courseImage: "",
      cultureDtoList: [],
    };
  },

  mounted() {
    this.getCompanyInfo();
  },
  // 获取Nav传来的数据
  methods: {
    //获取商品列表
    getCompanyInfo() {
      getCompanyInfoApi().then((res) => {
        // console.log("简介内容", res);
        this.content = res.data.content;
        this.courseImage = res.data.courseImage;
        this.cultureDtoList = res.data.cultureDtoList;
      });
    },
  },
};
</script>
<style scoped>
.CompanyProfile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-bottom: 140px;
}

.CompanyProfile_content {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*padding: 20px 0;*/
  /*font-size: 14px;*/
}

.CompanyProfile_title {
  /*font-size: 28px;*/
  /*font-weight: 600;*/
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 10px;
  /*padding-bottom: 60px;*/
  /*width: 1025px;*/
  width: 1200px;
  text-align: center;
}

.CompanyProfile_title_name {
  font-weight: 400;
  font-size: 26px;
  text-align: center;
}

.CompanyProfile_title_text {
  font-size: 14px;
  text-align: center;
}

.CompanyProfile_content_left {
  background-color: #a9c3e5;
  border-radius: 50%;
  width: 412px;
  height: 412px;
}

.about_us_img {
  width: 412px;
  height: 412px;
  border-radius: 50%;
}

.CompanyProfile_content_left img {
  width: 100%;
  margin-left: 50px;
}

.CompanyProfile_content_right_text {
  width: 600px;
  /* height: 300px; */

  display: inline;
  color: #2968bd;
  font-size: 22px;
  text-indent: 2em;
}

.CompanyProfile_content_right_text /deep/ img {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 12px 0;
  text-indent: 0;
}

.CompanyProfile_content_right_span {
  color: #333333;
  font-size: 18px;
}

.CompanyProfile_content_right {
  display: flex;
  justify-content: center;
  /*align-items: center;*/
  flex-direction: column;
  width: 583px;
  /* height: 290px; */
}

.CompanyProfile_content_right_p1 {
  /*padding-bottom: 35px;*/
  font-size: 48px;
  color: #2968bd;
}

.CompanyProfile_content_right_p2 {
  display: flex;
  justify-content: flex-end;
  font-size: 48px;
  color: #2968bd;
}

.CompanyProfile_foot {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /*width: 1200px;*/
}

.CompanyProfile_foot_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 10px;
  padding-bottom: 10px;
  /*padding-bottom: 60px;*/
  /*width: 1025px;*/
  width: 1200px;
  text-align: center;
}

.CompanyProfile_foot_title_name {
  font-weight: 400;
  font-size: 26px;
  text-align: center;
}

.CompanyProfile_foot_title_text {
  font-size: 14px;
  text-align: center;
}

.CompanyProfile_foot_img {
  display: flex;
  justify-content: center;
  max-width: 1920px;
}

.CompanyProfile_foot_img img {
  width: 100%;
}

.CompanyProfile_bottom {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
}

.CompanyProfile_bottom_title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 10px;
  /*padding-bottom: 60px;*/
  /*width: 1025px;*/
  width: 1200px;
  text-align: center;
}

.CompanyProfile_bottom_title_name {
  font-weight: 400;
  font-size: 26px;
  text-align: center;
}

.CompanyProfile_bottom_title_text {
  font-size: 14px;
  text-align: center;
}

.CompanyProfile_bottom_content {
  display: flex;
  justify-content: space-between;
  width: 1200px;
}

.CompanyProfile_bottom_content_div {
  width: 200px;
  height: 422px;
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
  align-items: center;
  border: 1px solid #888888;
  border-radius: 100px;
}

.CompanyProfile_bottom_content_div_img {
  margin-top: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2968bd;
  border-radius: 50%;
  width: 160px;
  height: 160px;
}

.CompanyProfile_bottom_content_div_text_left {
  color: #2968bd;
  font-size: 18px;
  text-align: center;
  padding-top: 26px;
  font-weight: bold;
}

.CompanyProfile_bottom_border {
  padding-top: 10px;
  text-align: center;
  margin: 0 auto;
  width: 34px;
  border-bottom: 3px solid #2968bd;
}

.CompanyProfile_bottom_content_div_text_right {
  padding-top: 30px;
  text-align: center;
  width: 96px;
  text-align: center;
  margin: 0 auto;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/CompanyProfile.vue